import React, { PureComponent } from 'react';

import LogOut from '../LogOut';
import s from './style/Header.pcss';


class Header extends PureComponent {
  render() {
    return (
      <div className={s.container}>
        <div className={s.burger}>
          <div className={s.burgerIcon} />
        </div>
        <div className={s.label}>
          Администрирование ПИК-Стандарт
        </div>
        <LogOut />
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Root/Main/Header.js